// l10n status: done
import { Dialog } from "@mui/material"
import { CreateComponent } from "components/utils/CreateComponent"
import { createElement, useEffect, useState } from "react"
import { rootStore } from "store/RootStore"
import closeModalSvg from "img/recordings/close_modal.svg"
import visibilitySvg from "img/player/visibility_white.svg"
import recordSeriesSvg from "img/player/record_series_white.svg"
import { Switch } from "scenes/components/ButtonComponents"
import { season, eventId } from "utils/EventHelpers"
import { l10n } from "store/lang/L10n"


import "./confirmationDialog.css"

//const guardTimes = [0, 2, 5, 10, 15, 30, 60]

export const RecordingsStartDialog = CreateComponent(null, false, true, props => {
	//const [anchorEl, setAnchorEl] = React.useState(null)

	const widthBreak = 540
	const dialogWidthNormal = 360
	const dialogWidthSmallAdjust = 58
	const dialogButtonWidthNormal = 328
	const dialogButtonWidthSmallAdjust = 58 + 36

	const [innerWidth, setInnerWidth] = useState(window.innerWidth)
	useEffect(() => {
		window.addEventListener("resize", handleResize)
		return () => {
			window.removeEventListener("resize", handleResize)
		}
	}, [])
	const handleResize = () => {
		setInnerWidth(window.innerWidth)
	}
	const { onCloseHandler, onAcceptHandler, bottomButtons, title, additionalInfo, oEvent, flagSeriesDefaultValue } = props
	//console.debug("RecordingsStartDialog", props)
	const [state, setState] = useState({
		seriesRecording: flagSeriesDefaultValue ?? false,
		hideSeriesRecording: flagSeriesDefaultValue !== null,
		privateRecording: true
	})

	const [guardTimeBefore, setGuardTimeBefore] = useState(10)
	const [guardTimeAfter, setGuardTimeAfter] = useState(30)

	const handleChange = (name, value) => {
		setState({ ...state, [name]: value })
		/*
		if (name === "seriesRecording") {
			const buttonLabel = value ? season(oEvent) ? l10n.dialogRecordSeasonNumberLabel.format(season(oEvent)) : l10n.dialogRecordSeriesLabel : l10n.dialogRecordSingleLabel
			bottomButtons[0].props.label = buttonLabel
		}
		*/
	}

	/* not used anymore
	const setGuardTime = (isUp, isBefore) => {
		const index = guardTimes.indexOf(isBefore === true ? guardTimeBefore : guardTimeAfter)
		if (index > -1) {
			const value = guardTimes[index + (isUp === true ? 1 : -1)]
			if (value !== void 0) {
				if (isBefore === true) {
					setGuardTimeBefore(value)
				} else {
					setGuardTimeAfter(value)
				}
			}
		}
	}
	*/

	const prepareTime = time => `PT${time}M`

	const visibilityLabel = <>
		<div className="RsdVisibilityIcon">
			<img className="buttonSvg" src={visibilitySvg}></img>
		</div>
		<div className="RsdLabel">
			{l10n.dialogRecordOnlyInThisProfileLabel}
		</div>
	</>

	const recordLabel = <>
		<div className="RsdSeriesIcon">
			<img className="buttonSvg" src={recordSeriesSvg}></img>
		</div>
		<div className="RsdLabel">
			{season(oEvent) ? l10n.dialogRecordSeasonLabel : l10n.dialogRecordSeriesLabel}
		</div>
	</>


	const confirmButtonHook = () => {
		onAcceptHandler({
			...props,
			...{
				recordSeries: state.seriesRecording,
				IsPersonal: state.privateRecording,
				seedEventId: !state.hideSeriesRecording ? null : eventId(oEvent),
				Arguments: {
					GuardTimeStart: prepareTime(guardTimeBefore),
					GuardTimeEnd: prepareTime(guardTimeAfter)
				}
			}
		})
	}


	return (
		<Dialog open={true} /*transition */
			placement="bottom-end"
			// MTVW-988: close on backdrop click
			disableBackdropClick="false"
			onClose={(event, reason) => {
				event.preventDefault()
				event.stopPropagation()
				if (reason === "backdropClick" || reason === "escapeKeyDown") {
					//console.debug("closing recording start dialog", event, reason)
					onCloseHandler()
				}
			}}
			sx={{
				zIndex: "1500 !important", // higher than OverlayEventDetails!
				"& .MuiDialog-container": {
					"& .MuiPaper-root": {
						//width: "360px",
						//height: "260px",
						//overflow: "visible",
						//margin: "unset",
						//padding: "unset"
						// MTVW-892: Fix fullscreen issue
						width: "unset !important",
						maxWidth: "unset !important"
					},
				},
				"& .MuiDialog-paper": {
					borderRadius: "16px",
					//boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
					//border: "2px #595959 solid"
				},
				"& .MuiModal-backdrop": {
					backgroundColor: 'rgba(48,48,48,0.8)',
				},
			}}
			//overlayStyle={{ backgroundColor: "#4C4C4C" }}
			// moved to .MuiModal-backdrop above
			//BackdropProps={{ style: { backgroundColor: "rgba(48,48,48,0.8)" } }}
			disablePortal={rootStore.page.Player.player.isFullScreen}
			data-test="vert_window">
			{/*{({ TransitionProps }) => (
				<Slide {...TransitionProps} timeout={350} direction="up">*/}

			<div id="recordingsStartDialog" className="ConfirmationDialog" style={{ width: innerWidth <= widthBreak ? innerWidth - dialogWidthSmallAdjust : dialogWidthNormal }}>
				<div className="ConfirmationCloseContainer" data-test="cancel " onClick={() => onCloseHandler()}>
					<img className="ConfirmationCloseIcon" src={closeModalSvg}></img>
				</div>
				<div className="ConfirmationTitleFrame">
					<div className="ConfirmationTitleContainer">
						<div className="ConfirmationTitleText">{title}</div>
					</div>
				</div>
				<div className="RsdContent">
				{/* MTVW-1094: only private recording for adult channels*/}
					{!rootStore.channelsService?.isAdultChannel(oEvent?.channel?.id) &&
					<div className="RsdToggle" >
						<Switch onState={state.privateRecording} label={visibilityLabel} onClick={() => handleChange("privateRecording", !state.privateRecording)} dataTest="private_recording_flag" />
					</div>
					}
					{!state.hideSeriesRecording &&
						<div className="RsdToggle" >
							<Switch onState={state.seriesRecording} label={recordLabel} onClick={() => handleChange("seriesRecording", !state.seriesRecording)} dataTest="series_recording_flag" />
						</div>
					}
				</div>
				<div className="ConfirmationBottomButtonsSection">
					{bottomButtons &&
						bottomButtons.map((item, ix) => {
							//console.debug("item.props", item.props)
							// intercept confirm button
							if (item?.props?.isConfirmButton) {
								item.props.onClick = confirmButtonHook
								const buttonLabel = state.seriesRecording ? season(oEvent) ? l10n.dialogRecordSeasonNumberLabel.format(season(oEvent)) : l10n.dialogRecordSeriesLabel : l10n.dialogRecordSingleLabel
								item.props.label = buttonLabel
							}
							if (item?.props) {
								item.props.inModal = true
								item.props.width = innerWidth <= widthBreak ? innerWidth - dialogButtonWidthSmallAdjust : dialogButtonWidthNormal
							}
							if (item?.bType) return <div key={ix}>{createElement(item.bType, item.props, null)}</div>
						})
					}
				</div>
			</div>
		</Dialog>
	)
})
